import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import useSwitchChild from '@/hooks/useSwitchChild';
import { pathDashboard, route } from '@/constants/routeName';
import Navigation from '@/components/Navigation/Navigation';

/**
 * Empty state when a parent has no active child.
 * Picks use the same switchChild handler as the header selector.
 */
export default function NoChildSelected() {
	const navigate = useNavigate();
	const { switchChild, switchingLocked, children } = useSwitchChild();
	const user = useSelector((state) => state.auth.user);

	const zero = children.length === 0;
	const title = zero ? 'No children linked' : 'Select a child';
	const body = zero
		? 'Your account has no linked students yet. Ask the school office to link a child, or sign out and try again later.'
		: 'Choose which child you want to order for.';

	const onSelect = (id) => {
		const result = switchChild(id);
		if (!result.ok) return;
		navigate(`/${route.menu}`);
	};

	return (
		<section className='app-container'>
			<div className='inner-container flex flex-col gap-4 px-6 pb-24 pt-10'>
				<p className='text-sm text-[var(--weak)]'>
					Signed in as {user?.name || user?.email || 'parent'}
				</p>
				<h1 className='text-xl font-bold text-black'>{title}</h1>
				<p className='text-base text-[var(--weak)]'>{body}</p>
				<Link to={pathDashboard} className='text-sm font-bold text-black underline'>
					Back to family dashboard
				</Link>
				{children.length > 0 && (
					<ul className='mt-2 flex flex-col gap-2'>
						{children.map((child) => (
							<li key={child.id}>
								<button
									type='button'
									className='btn-actions w-full rounded-md px-4 py-3 text-left text-white'
									disabled={switchingLocked}
									onClick={() => onSelect(child.id)}
								>
									<span className='block font-semibold'>
										{child.member?.name || `Child #${child.id}`}
									</span>
									<span className='block text-sm opacity-80'>
										{child.member?.on_list_attributes?.class || 'Class unknown'}
									</span>
								</button>
							</li>
						))}
					</ul>
				)}
			</div>
			<Navigation />
		</section>
	);
}
